import { Warrant } from 'data/warrant/warrant.types';

// eslint-disable-next-line import/prefer-default-export
export const warrantModel: Warrant = {
  id: '',
  templateUsed: '',
  dxOwner: '',
  dxAccess: '',
  name: '',
  province: '',
  city: '',
  comments: '',
  contact: null,
  judge: '',
  receivedDateTime: '',
  region: '',
  startDateTime: '',
  stopDateTime: '',
  timeZone: '',
  cases: [],
  attachments: [],
  department: '',
  division: '',
};
